import { Type } from '@scalar/typebox';
import { array, object, optional, string } from '@scalar/validation';
const XScalarLinkItemSchema = Type.Object({
    name: Type.String(),
    url: Type.String(),
});
export const XScalarLinksSchema = Type.Object({
    'x-scalar-links': Type.Optional(Type.Array(XScalarLinkItemSchema)),
});
const XScalarLinkItem = object({
    name: string(),
    url: string(),
}, {
    typeName: 'XScalarLinkItem',
    typeComment: 'A named link to display alongside the API info',
});
export const XScalarLinks = object({
    'x-scalar-links': optional(array(XScalarLinkItem, {
        typeComment: 'Additional named links to display alongside the API info (e.g. privacy policy, imprint)',
    })),
}, {
    typeName: 'XScalarLinks',
    typeComment: 'Additional named links to display alongside the API info',
});
